module.exports = __webpack_public_path__ + "img/penrose-logo.acfbb1ce.png";